/* ============================================================
   Feature rows (snippets/ak-feature-row.liquid)
   1. Mobile dots follow the swipe position.
   2. Video panels play muted only while on screen; with
      reduced motion they stay on their poster frame.
   Delegated to document so it survives the facet AJAX re-render.
   ============================================================ */
(function () {
  if (window.__akFeatureRowInit) return;
  window.__akFeatureRowInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateDots(strip) {
    var row = strip.closest('[data-ak-frow]');
    if (!row) return;
    var dots = row.querySelectorAll('.ak-frow__dots i');
    if (!dots.length) return;
    var centre = strip.scrollLeft + strip.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    Array.prototype.forEach.call(strip.children, function (panel, i) {
      var mid = panel.offsetLeft - strip.offsetLeft + panel.offsetWidth / 2;
      var d = Math.abs(mid - centre);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.classList.toggle('is-active', i === best);
    });
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-ak-frow-strip')) updateDots(t);
  }, { capture: true, passive: true });

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reduceMotion.matches) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
  }

  function bindVideos(root) {
    if (!io) return;
    var vids = (root || document).querySelectorAll('[data-ak-frow] video:not([data-ak-bound])');
    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('data-ak-bound', '');
      v.muted = true;
      io.observe(v);
    });
  }

  function init() {
    bindVideos(document);
    // Facet filtering swaps the grid markup; rebind new videos.
    var grid = document.getElementById('product-grid');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { bindVideos(grid); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
